// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"daemonMessageView__wrapper","progress":"daemonMessageView__progress","message":"daemonMessageView__message","link":"daemonMessageView__link"};